import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { TranslatEN } from './assets/locales/en/translations';
import { TranslatDE } from './assets/locales/de/translations';

i18n
  .use(initReactI18next)  // Passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: TranslatEN },
      de: { translation: TranslatDE }
    },
    lng: 'en',
    interpolation: {
      escapeValue: false  // React already safes from xss
    }
  });

export default i18n;